import { stringify } from 'querystring';
import { camelizeKeys } from 'humps';

import { Product } from '@bucketplace/common';

import { clientHttp } from 'common/http';

import { SectionItemsResponse, ResponseGetCouponMoldsPublish, CommonPublishProductCoupon } from 'promotions/types';

import { fetcher } from 'api/fetcher';

export const publishCartCouponMolds = async (
  { id }: { id: number }
): Promise<ResponseGetCouponMoldsPublish> => {
  const res = await fetcher<ResponseGetCouponMoldsPublish>(`/api/promotions/coupon/${id}`);
  return res;
};

export const publishProductCouponMolds = async (
  { id, userId }: { id: number, userId: string }
): Promise<CommonPublishProductCoupon> => {
  const json = await clientHttp.post('/api/promotions/product-coupon/create', {
    json: {
      couponMoldId: id,
      userId,
    },
  }).json();
  return camelizeKeys(json) as CommonPublishProductCoupon;
};

export const getStoreItems = async (
  {
    ids,
    isLoggedIn,
    showCouponBadge,
  }: {
    ids: string[],
    isLoggedIn: boolean,
    showCouponBadge: boolean,
  }
): Promise<Product[]> => {
  try {
    const res = await fetcher<Product[]>(
      `/api/promotions/store-items?${stringify({
        ids: ids.join(','),
        isLoggedIn,
        showCouponBadge,
      })}`
    );

    return res.map((item) => ({
      ...item,
      id: Number(item.id),
    }));
  } catch (error) {
    return [];
  }
};

export const getSectionItems = async (
  id: string,
  detailId: string,
  {
    sectionId,
    page,
  }: {
    sectionId?: string,
    page: number,
  }
): Promise<SectionItemsResponse> => {
  const res = await fetcher<SectionItemsResponse>(
    `/api/promotions/${id}/section-items?${stringify({
      sectionId,
      detailId,
      page,
    })}`
  );

  return res;
};

export const getExhibitionSectionItems = async (url): Promise<SectionItemsResponse['sectionItems']> => {
  const res = await fetcher<SectionItemsResponse>(url);

  return res.sectionItems;
};
